import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid2 as Grid } from '@mui/material';

import CounterWithTrend from '../../../../../../DesignSystem/CounterWithTrend';

function Kpis({ data, isFetching }: any) {
  return (
    <Grid container spacing={3}>
      {data?.total_users >= 0 && (
        <Grid size={{ lg: 3, md: 4, xs: 6 }}>
          <CounterWithTrend
            label={
              <FormattedMessage
                id="STATS.KPIS.TOTAL_PARTICIPANTS"
                values={{ count: data?.total_users }}
              />
            }
            value={data?.total_users}
            loading={isFetching}
            variant="outlined"
          />
        </Grid>
      )}

      {data?.total_ideas >= 0 && (
        <Grid size={{ lg: 3, md: 4, xs: 6 }}>
          <CounterWithTrend
            label={<FormattedMessage id="STATS.TOTAL_IDEAS" />}
            value={data?.total_ideas}
            loading={isFetching}
            variant="outlined"
          />
        </Grid>
      )}

      {data?.total_form_reponses >= 0 && (
        <Grid size={{ lg: 3, md: 4, xs: 6 }}>
          <CounterWithTrend
            label={
              <FormattedMessage
                id="STATS.KPIS.TOTAL_FORM_RESPONSES"
                values={{ count: data?.total_form_reponses }}
              />
            }
            value={data?.total_form_reponses}
            loading={isFetching}
            variant="outlined"
          />
        </Grid>
      )}

      {data?.total_comments >= 0 && (
        <Grid size={{ lg: 3, md: 4, xs: 6 }}>
          <CounterWithTrend
            label={
              <FormattedMessage
                id="STATS.KPIS.TOTAL_COMMENTS"
                values={{ count: data?.total_comments }}
              />
            }
            value={data?.total_comments}
            loading={isFetching}
            variant="outlined"
          />
        </Grid>
      )}

      {data?.total_votes >= 0 && (
        <Grid size={{ lg: 3, md: 4, xs: 6 }}>
          <CounterWithTrend
            label={<FormattedMessage id="STATS.TOTAL_VOTES" />}
            value={data?.total_votes}
            loading={isFetching}
            variant="outlined"
          />
        </Grid>
      )}
    </Grid>
  );
}

export default Kpis;
